import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-cdn-icon',
  templateUrl: './cdn-icon.component.html',
  styleUrls: ['./cdn-icon.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})

export class CdnIconComponent implements OnInit {

  ngOnInit() { }

  @Input() src: string;

  constructor(
    public utils: UtilsService
  ) { }

  assembleIconLink(assetPath: string): string {
    // icons are fetched from the backend 
    // so make sure that you have icons added asset folder
    return this.utils.getCDNAsset('icon/' + assetPath);
  }

}
